import withSelectFormik from '../withSelectFormik';
import withOptionsSelectValueInitById from '../withOptionsSelectValueInitById';
import options from './options';

export default withSelectFormik(withOptionsSelectValueInitById(options, options[0]));
